module.exports = __webpack_public_path__ + "9959eec6f04d2f557f29ba6e44044106.svg";